import React from "react"
import { useTranslation } from "react-i18next"

import { ProductInformation } from "shared/types/__generated__/graphql"
import { Label } from "shared/ui/label/Label"
import { PropertyList } from "shared/ui/property-list/PropertyList"

export interface ProductConfiguratorSummaryCardAddonsProps {
  addons: ProductInformation[] | null | undefined
  isLoading?: boolean
}

export const ProductConfiguratorSummaryCardAddons = React.memo(
  ({ addons, isLoading }: ProductConfiguratorSummaryCardAddonsProps) => {
    const { t } = useTranslation()

    if (!addons?.length && !isLoading) {
      return (
        <Label className="product-configurator-summary-card__empty">
          {t("Product.Configuration.Addon.NoneSelected")}
        </Label>
      )
    }

    return (
      <div className="product-configurator-summary-card__addons">
        {addons?.map(addon => (
          <div
            key={addon.variantKey}
            className="product-configurator-summary-card__addon"
          >
            <Label
              variant="bold"
              className="product-configurator-summary-card__addon-title"
            >
              {addon.title}
            </Label>
            <PropertyList list={addon.attributes} isLoading={isLoading} />
          </div>
        ))}
      </div>
    )
  }
)
